import * as React from 'react';
import { Radio as AntdRadio } from 'antd';
import './Radio.css';
import PropTypes from 'prop-types';

const propTypes =  {
	values: PropTypes.any,
	textClasses: PropTypes.any,
	checkedIndex: PropTypes.any,
	onChange: (e) => {}
}

function Radio(props) {
	return (
		<div className="RadioGroup" data-test="RadioGroup">
			<AntdRadio.Group defaultValue={props.checkedIndex} onChange={props.onChange}>
				{props.values.map((value, index) => {
					return (
						<AntdRadio
							className={
								(index === 0
									? `${props.textClasses || ''} radio-first`
									: props.textClasses || '')
							}
							key={index}
							value={index}
						>
							{value}
						</AntdRadio>
					);
				})}
			</AntdRadio.Group>
		</div>
	);
}
Radio.propTypes = propTypes;

export default Radio;



// WEBPACK FOOTER //
// ./src/components/radios/Radio.jsx